import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _get from 'lodash/get';
import _omitBy from 'lodash/omitBy';
import _isNil from 'lodash/isNil';
import { post } from 'utils/api';
import Config from 'utils/getEnvConfig';
import { getBrandValue } from 'utils/brandUtils';
import useContentfulLocale from 'components/useContentfulLocale';
import { makeSelectAuth } from 'containers/Auth/selectors';
import { isSignUpPeriod } from 'utils/authUtils';

const {
  LAMBDA: {
    FIREBASE_HELPER: { REQUEST_EMAIL_VERIFICATION_URL, API_KEY },
  },
} = Config;

/**
 * useRequestEmailVerification
 * Calls the email verification endpoint and redirects to /signup/verify
 * Usage: const requestEmailVerification = useRequestEmailVerification();
 *        requestEmailVerification();
 */
export default function useRequestEmailVerification() {
  const auth = useSelector(makeSelectAuth());
  const history = useHistory();
  const { locale } = useContentfulLocale();

  /**
   * @param {string} [redirect] - Optional redirect path to append as query param
   */
  return useCallback(
    redirect => {
      const token = _get(auth, 'stsTokenManager.accessToken');
      const isSignUp = isSignUpPeriod(auth);
      if (!token) return; // Only trigger if token exists
      const data = {
        token,
        brand: getBrandValue(),
        locale,
      };
      if (!isSignUp)
        post(REQUEST_EMAIL_VERIFICATION_URL, _omitBy(data, _isNil), {
          headers: {
            'x-api-key': API_KEY,
          },
        });
      if (redirect) {
        history.push(`/signup/verify?redirect=${encodeURIComponent(redirect)}`);
      } else {
        history.push('/signup/verify');
      }
    },
    [auth, history, locale],
  );
}
